import { ChevronDown } from 'lucide-react';
import React, { forwardRef } from 'react';
import { DataWrapper } from '~/primitives/input';
import { cn } from '~/util';

export const InteractableDataWrapper = forwardRef<
    HTMLDivElement,
    React.HTMLProps<HTMLDivElement> & {
        disabled?: boolean;
        open?: boolean;
    }
>(({ children, open, disabled, ...props }, ref) => {
    return (
        <DataWrapper disabled={disabled} {...props} ref={ref}>
            {children}

            {!disabled && (
                <ChevronDown
                    className={cn(
                        'min-h-5 min-w-5 max-h-5 max-w-5 transition-all text-primary',
                        open && 'transform rotate-180',
                    )}
                />
            )}
        </DataWrapper>
    );
});

InteractableDataWrapper.displayName = 'InteractableDataWrapper';
